import { render, staticRenderFns } from "./EVChargerComparison.vue?vue&type=template&id=23d1ce82&scoped=true&"
import script from "./EVChargerComparison.vue?vue&type=script&lang=js&"
export * from "./EVChargerComparison.vue?vue&type=script&lang=js&"
import style0 from "./EVChargerComparison.vue?vue&type=style&index=0&id=23d1ce82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d1ce82",
  null
  
)

export default component.exports